heat_treatments-table
  section.app-table
    header.app-table-header
      .row
        .col-12.col-md-11 { opts.locale.header.name.label }
        .col-12.col-md-1.text-right
    .app-table-body
      .row(each="{ opts.items }")
        .col-12.col-md-11 { name }
        .col-12.col-md-1.text-right
          a.btn.btn-primary.editable(href="{ edit_path }")
            i.feather.icon-edit
  shared-paginate(tag-scope="{this.tagScope}.paginate")
  script(type="typescript").
    this.mixin('table');
  style(scoped).
    :scope {
      display: block;
    }
